import 'swiper/css'

import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import image1 from '../../assets/images/pages/article-1/1.jpg'
import image2 from '../../assets/images/pages/article-1/2.jpg'
import image3 from '../../assets/images/pages/article-1/3.jpg'
import image4 from '../../assets/images/pages/article-1/4.jpg'
import image5 from '../../assets/images/pages/article-1/5.jpg'
import image6 from '../../assets/images/pages/article-1/6.jpg'
import image7 from '../../assets/images/pages/article-1/7.jpg'
import image8 from '../../assets/images/pages/article-1/8.jpg'
import image9 from '../../assets/images/pages/article-1/9.jpg'
import belinskaya from '../../assets/images/pages/article-1/belinskaya.png'
import kamisheva from '../../assets/images/pages/article-1/kamisheva.png'
import shapiro from '../../assets/images/pages/article-1/shapiro.png'
import { Articles } from '../../components/Article/Articles/Articles'
import { CollectionBanner } from '../../components/Collection/CollectionBanner/CollectionBanner'
import { Feedback } from '../../components/Feedback/Feedback'
import { Footer } from '../../components/Footer/Footer'
import { Header } from '../../components/Header/Header'
import { BackButton } from '../../components/UI/BackButton/BackButton'
import styles from '../../pages/ArticlesPage/articlePage.module.scss'
import { handleAnalyticsLink } from '../ArticlesPage/ArticlePage'

export const ArticlePage1 = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <>
      <Header />
      <main className={`${styles.articlePage} ${styles.article1}`}>
        <section className={styles.articleIntro}>
          <BackButton url='/' />

          <h1>
            <b>Эффект масштаба:</b> <br />
            что такое жилые кластеры и&nbsp;чем они хороши
          </h1>

          <div className={styles.articleLead}>
            Тренд последних лет в&nbsp;мировом урбанизме&nbsp;&mdash; изменение
            функции промышленных зон на&nbsp;жилую или общественную.
            В&nbsp;России в&nbsp;качестве примеров можно назвать застройку
            территории &laquo;Москва-Сити&raquo;, бывшего завода &laquo;Серп
            и&nbsp;Молот&raquo;, &laquo;ЗИЛ&raquo;. Крупную жилую застройку
            с&nbsp;развитой инфраструктурой называют жилым кластером.
            Рассказываем, в&nbsp;чем специфика современных жилых кластеров,
            какие существуют стандарты и&nbsp;подходы в&nbsp;освоении крупных
            территорий.
          </div>

          <div className={styles.articleIntroImg}>
            <img src={image1} alt={''} />
          </div>
        </section>

        <section className={styles.articleContent}>
          <h2 className={styles.articleContentTitle}>
            Что дает комплексный подход к&nbsp;застройке
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Редевелопмент бывших индустриальных территорий позволяет создать
                фактически новый район, где не&nbsp;будет ни&nbsp;следа
                от&nbsp;устаревшей инфраструктуры, а&nbsp;новое пространство
                будет спланировано и&nbsp;построено по&nbsp;современным мировым
                стандартам.
              </p>
              <p>
                Преимущество таких пространств в&nbsp;том, что это крупные
                городские территории, которые сейчас находятся недалеко
                от&nbsp;центра. Локация и&nbsp;площадь дают возможность подойти
                к&nbsp;их&nbsp;развитию комплексно&nbsp;&mdash; от&nbsp;создания
                законченного архитектурного образа до&nbsp;развитой
                социально-экономической инфраструктуры,&nbsp;&mdash; считает
                партнер бюро Wowhaus Олег Шапиро. По&nbsp;его мнению, помимо
                постройки самих жилых домов, здесь могут быть учтены все аспекты
                современной жизни: парки, бульвары и&nbsp;зеленые территории для
                досуга, необходимое количество детских садов и&nbsp;школ для
                воспитания детей, а&nbsp;также объекты медицинского
                обслуживания.
              </p>
              <p>
                &laquo;Комплексный подход к&nbsp;планированию и&nbsp;застройке
                территории, с&nbsp;одной стороны, дает возможность заранее
                учесть запросы людей на&nbsp;привлекательную, благоприятную
                и&nbsp;безопасную среду для жизни, запрограммировать актуальные
                сценарии использования территории,&nbsp;&mdash; считает
                руководитель проектов бюро Atlas Анна Белинская.
                &mdash;&nbsp;А&nbsp;с&nbsp;другой&nbsp;&mdash; грамотно
                интегрировать территорию в&nbsp;городскую ткань. Такая
                интеграция в&nbsp;контекст города предполагает включение
                пространства в&nbsp;городскую экономику: расположение
                на&nbsp;территории бывших производственных зон дефицитных для
                города и&nbsp;прилегающего района функций, а&nbsp;также создание
                связной системы транспортно-пешеходных перемещений&raquo;.
              </p>
            </div>
          </div>

          <div className={styles.articleDescrImg}>
            <img src={image2} alt={''} />
          </div>

          <h2 className={styles.articleContentTitle}>
            Жилые кластеры: плюсы и&nbsp;минусы
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Для города крупные проекты, состоящие
                из&nbsp;10&nbsp;и&nbsp;более корпусов с&nbsp;благоустройством
                и&nbsp;соответствующей такому масштабу инфраструктурой,
                не&nbsp;новинка. Такие проекты есть и&nbsp;у&nbsp;ПИК.
                Но&nbsp;компания не&nbsp;просто укрупняет, а&nbsp;развивает
                территорию застройки и&nbsp;создает жилой кластер. В&nbsp;своей
                концепции жилого кластера девелопер объединяет несколько
                кварталов и&nbsp;создает для них новые пространства
                и&nbsp;сервисы, закрывающие большую часть ежедневных
                потребностей жителей. По&nbsp;сути кластер создает новый жилой
                контекст, &laquo;с&nbsp;иголочки&raquo;: зона комфорта
                распространяется не&nbsp;только на&nbsp;подъезд, двор, парковку
                и&nbsp;школу рядом&nbsp;&mdash; можно жить в&nbsp;заново
                построенном городском районе, консистентной благополучной
                и&nbsp;современной среде.
              </p>
            </div>
          </div>
        </section>

        <section
          className={styles.articleProduct}
          style={{ background: '#e4f0d5' }}
        >
          <div
            className={styles.articleProductContainer}
            style={{ marginBottom: 0 }}
          >
            <div
              className={
                (styles.articleProductRowTop,
                styles['articleProductRowTop--article-1'])
              }
            >
              <h2 className={styles.articleProductTitle}>
                Что такое жилой кластер
              </h2>
              <div className={`${styles.articleProductImg} for-mobile`}>
                <img src={image3} alt={''} />
              </div>
            </div>
            <div className={styles.articleProductRow}>
              <div className={styles.articleProductCol}>
                <div className={`${styles.articleProductImg} for-desktop768`}>
                  <img src={image3} alt={''} />
                </div>
              </div>
              <div className={styles.articleProductCol}>
                <div className={styles.articleSpeaker}>
                  <img src={kamisheva} alt='Дарья Камышева' />
                  <div className={styles.articleProductText}>
                    <span className={styles.articleProductName}>
                      Дарья Камышева,
                    </span>{' '}
                    вице-президент, директор департамента продукта ПИК:
                  </div>
                </div>

                <div className={styles.articleProductText}>
                  <p>
                    &mdash;&nbsp;ПИК стал одним из&nbsp;первых в&nbsp;отрасли,
                    кто стал применять комплексный подход к&nbsp;развитию
                    масштабных территорий и&nbsp;проектированию не&nbsp;просто
                    жилых кварталов, а&nbsp;цельной современной
                    среды&nbsp;&mdash; кластеров. И&nbsp;речь идет
                    не&nbsp;столько об&nbsp;образовательной, социальной
                    инфраструктуре и&nbsp;благоустроенных дворах, которые давно
                    стали нормой девелоперского продукта, сколько
                    о&nbsp;формировании новых общественных пространств
                    и&nbsp;сервисов. Удаленная работа и&nbsp;образование,
                    встречи с&nbsp;друзьями, занятия спортом и&nbsp;ментальным
                    здоровьем, прогулки с&nbsp;домашними питомцами&nbsp;&mdash;
                    буквально все должно быть продумано до&nbsp;мелочей.
                    <br />
                    <br />
                  </p>
                  <p>
                    Так, например, в&nbsp;Матвеевском кластере в&nbsp;районе
                    Очаково-Матвеевское появится многокилометровый пешеходный
                    бульвар и&nbsp;мост. Они станут своеобразной зеленой
                    артерией кластера, к&nbsp;которой будут стекаться
                    прогулочные маршруты, велосипедные дорожки, рядом
                    расположатся пекарни и&nbsp;коворкинги, сенсорные сады
                    и&nbsp;плейхабы. Мы&nbsp;тщательно планируем
                    и&nbsp;сценируем жизнь в&nbsp;районе, насыщаем наши проекты
                    источниками впечатлений, чтобы создавалась атмосфера
                    добрососедства и&nbsp;каждый чувствовал сопричастность
                    с&nbsp;местом.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <div
          className={`
              ${styles.articleContentItemIllustartion} ${styles.articleContentItemIllustartion3}
            `}
        >
          <div className={styles.articleTitle}>Комплексный подход</div>
          <div className={styles.articleText}>
            Такая интеграция в&nbsp;контекст города предполагает в&nbsp;этом
            числе её&nbsp;включение в&nbsp;городскую экономику
          </div>
        </div> */}

        <section
          className={styles.articleProduct}
          style={{ background: '#e3d3f7' }}
        >
          <div className={styles.articleProductContainer}>
            <div className={styles.articleProductRowTop}>
              <h2 className={styles.articleProductTitle}>Главное о проекте:</h2>
              <div className={`${styles.articleProductImg} for-mobile`}>
                <img src={image4} alt={''} />
              </div>
            </div>
            <div className={styles.articleProductRow}>
              <div className={styles.articleProductCol}>
                <div className={`${styles.articleProductImg} for-desktop768`}>
                  <img src={image4} alt={''} />
                </div>
              </div>
              <div className={styles.articleProductCol}>
                <div className={styles.articleProductText}>
                  <p>
                    <b>Расположение:</b> Москва, Очаково-Матвеевский район
                    <br />
                    <b>Проекты в&nbsp;составе:</b> &laquo;Матвеевский
                    парк&raquo;, &laquo;Большая Очаковская&nbsp;2&raquo;,
                    &laquo;Новое Очаково&raquo;, Vangarden
                    <br />
                    <b>Площадь участка:</b> 66,7&nbsp;Га
                    <br />
                    <b>Площадь строительства:</b> 31,4&nbsp;Га
                    <br />
                    <b>Число корпусов:</b> 96&nbsp;корпусов
                    <br />
                    <b>Число квартир:</b> 26&nbsp;505
                    <br />
                    <b>Этажность:</b> 9&ndash;33
                    <br />
                    <b>Площадь квартир:</b> 1&nbsp;151&nbsp;533&nbsp;кв&nbsp; м
                    <br />
                    <b>Фасад:</b> Навесные панели с&nbsp;рельефным кирпичом
                    и&nbsp;керамической плиткой, вентилируемые навесные
                    с&nbsp;бетонной плиткой
                    <br />
                    <b>Инфраструктура:</b> 6&nbsp;детских садов,
                    3&nbsp;общеобразовательные школы, 2&nbsp;начальные школы,
                    торговый центр
                    <br />
                    <b>Благоустройство:</b> дворы-парки с&nbsp;зонами для
                    отдыха, занятий спортом и&nbsp;детских игр, пешеходный
                    бульвар от&nbsp;бюро Gillespies с&nbsp;сухим фонтаном,
                    местами для отдыха, зонами для воркаута и&nbsp;командных
                    видов спорта, велодорожками, площадка для выгула собак,
                    пешеходный мост
                    <br />
                    <b>Парковка:</b> подземный паркинг, плоскостной паркинг
                    <br />
                    <b>Архитектор:</b> ПИК, бюро de&nbsp;Architekten Cie
                    (Vangarden)
                    <br />
                    <b>Девелопер:</b> ПИК
                    <br />
                    <b>Очереди строительства:</b> 27
                    <br />
                    <b>Сроки строительства:</b> 2&nbsp;кв.&nbsp;2031
                  </p>
                </div>
                <a
                  className={`${styles.articleButton}`}
                  href={
                    'https://www.pik.ru/cluster/matveevsky?utm_source=rbc&utm_medium=display&utm_content=matveevsky'
                  }
                  target='_blank'
                  onClick={() => {
                    handleAnalyticsLink(1, 'Подробнее о&nbsp;проекте')
                  }}
                >
                  Подробнее о&nbsp;проекте
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.articleContent}>
          <div className={styles.articleDescrImg}>
            <img src={image5} alt={''} />
          </div>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Строительство нового района с&nbsp;нуля является одним
                из&nbsp;основных преимуществ кластерной застройки
                по&nbsp;сравнению с&nbsp;точечной, когда необходимо встраиваться
                в&nbsp;существующий район. Такой подход позволяет обеспечить
                жителей всей необходимой инфраструктурой&nbsp;&mdash; школы
                и&nbsp;детские сады, коммерческие объекты, пространства для
                досуга, услуги и&nbsp;сервисы под разные предпочтения
                и&nbsp;запросы. И&nbsp;всё это&nbsp;&mdash; в&nbsp;единой
                концепции, позволяющей соблюсти баланс между потребностями, без
                избыточности, дублирования, изоляции одного проекта
                от&nbsp;другого. Кроме того, в&nbsp;кластерах можно изначально
                спланировать продуманный транспортный каркас&nbsp;&mdash;
                удобную дорожную сеть и&nbsp;общественный транспорт. Здесь
                всегда есть метро или железнодорожная станция, которая как
                минимум половину пропускной способности ориентирует именно
                на&nbsp;жителей кластера.
                <br />
                <br />
              </p>
              <p>
                Среди минусов крупных проектов эксперты называют более
                длительную реализацию в&nbsp;сравнении с&nbsp;точечной
                застройкой. При этом современный подход к&nbsp;застройке
                обеспечивает жителей даже самых первых очередей и&nbsp;базовой
                инфраструктурой и&nbsp;качественным благоустройством прилегающей
                территории.
              </p>
            </div>
          </div>

          <h2 className={styles.articleContentTitle}>
            Сравнение кластерных с&nbsp;точечными проектами
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleTable}>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Точечные проекты</th>
                    <th>Кластер</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <b>Формат строительства</b>
                    </td>
                    <td>Интеграция проекта в&nbsp;сложившийся район</td>
                    <td>Строительство собственного современного района</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Инфраструктура и&nbsp;благоустройство</b>
                    </td>
                    <td>
                      Объекты инфраструктуры и&nbsp;благоустройства,
                      ограниченные одним проектом
                    </td>
                    <td>
                      Разнообразие объектов инфраструктуры
                      и&nbsp;благоустройства за&nbsp;счёт близости нескольких
                      проектов
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Квартиры</b>
                    </td>
                    <td>
                      Сроки строительства, стоимость и&nbsp;варианты отделки
                      определены проектом
                    </td>
                    <td>
                      Возможность выбора между разной стоимостью и&nbsp;сроками
                      строительства в&nbsp;интересующей локации
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className={styles.articleDescrImg}>
            <img src={image6} alt={''} />
          </div>

          <h2 className={styles.articleContentTitle}>
            Что дают масштабные проекты жителям и&nbsp;городу
          </h2>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                Для жителей польза от&nbsp;таких проектов в&nbsp;том, что они
                получают всю необходимую инфраструктуру рядом с&nbsp;домом.
                &laquo;У&nbsp;них нет потребности выезжать за&nbsp;пределы
                квартала, чтобы сходить в&nbsp;магазин или прогуляться
                с&nbsp;детьми. Это приводит в&nbsp;свою очередь к&nbsp;снижению
                нагрузки на&nbsp;транспортную систему города и&nbsp;уменьшению
                количества пробок. Учитывая, что для крупных городов проблема
                загруженности дорог стоит крайне остро, застройка промзон жилыми
                кварталами с&nbsp;комплексной инфраструктурой может стать
                успешным решением&raquo;,&nbsp;&mdash; говорит партнер архбюро
                UTRO Ольга Хохлова.
              </p>
            </div>
          </div>
        </section>

        <section
          className={styles.articleProduct}
          style={{ background: '#e4f0d5' }}
        >
          <div
            className={styles.articleProductContainer}
            style={{ marginBottom: 0 }}
          >
            <div
              className={
                (styles.articleProductRowTop,
                styles['articleProductRowTop--article-1'])
              }
            >
              <h2 className={styles.articleProductTitle}>
                Кластер&nbsp;&mdash; это воплощение концепции 15-минутного
                города для жителей
              </h2>
              <div className={`${styles.articleProductImg} for-mobile`}>
                <img src={image7} alt={''} />
              </div>
            </div>
            <div className={styles.articleProductRow}>
              <div className={styles.articleProductCol}>
                <div className={`${styles.articleProductImg} for-desktop768`}>
                  <img src={image7} alt={''} />
                </div>
              </div>
              <div className={styles.articleProductCol}>
                <div className={styles.articleSpeaker}>
                  <img src={shapiro} alt='Олег Шапиро' />
                  <div className={styles.articleProductText}>
                    <span className={styles.articleProductName}>
                      Олег Шапиро,
                    </span>{' '}
                    партнер бюро Wowhaus:
                  </div>
                </div>
                <div className={styles.articleProductText}>
                  <p>
                    &mdash;&nbsp;Поскольку бывшие промзоны&nbsp;&mdash; это
                    довольно крупные территории, их&nbsp;можно рассматривать как
                    самостоятельные и&nbsp;даже несколько замкнутые на&nbsp;себе
                    зоны: здесь можно реализовать концепцию 15-минутного или
                    просто доступного города, когда жители получают все сервисы
                    в&nbsp;пешеходной или велосипедной доступности. Так как
                    здесь может проживать довольно большое количество людей,
                    то&nbsp;и&nbsp;количества запросов на&nbsp;городские сервисы
                    будет высокое.
                    <br />
                    <br />
                  </p>
                  <p>
                    Хорошо, когда в&nbsp;таких проектах грамотно проработана
                    городская среда&nbsp;&mdash; пешеходная зона отделена
                    от&nbsp;автомобильной, опасной городской территории. Здесь
                    могут безопасно находится дети, а&nbsp;для удобства разных
                    категорий людей может быть сформирована безбарьерная среда.
                    Такой масштаб социального пространства дает возможность
                    тщательно организовать его по&nbsp;всем современным
                    требованиям.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className={styles.articleProduct}
          style={{ background: '#e3d3f7' }}
        >
          <div className={styles.articleProductContainer}>
            <div
              className={
                (styles.articleProductRowTop,
                styles['articleProductRowTop--article-1'])
              }
            >
              <h2 className={styles.articleProductTitle}>
                Комплексная застройка для города и&nbsp;будущих жильцов
              </h2>
              <div className={`${styles.articleProductImg} for-mobile`}>
                <img src={image8} alt={''} />
              </div>
            </div>
            <div className={styles.articleProductRow}>
              <div className={styles.articleProductCol}>
                <div className={`${styles.articleProductImg} for-desktop768`}>
                  <img src={image8} alt={''} />
                </div>
              </div>
              <div className={styles.articleProductCol}>
                <div className={styles.articleSpeaker}>
                  <img src={belinskaya} alt='Анна Белинская' />
                  <div className={styles.articleProductText}>
                    <span className={styles.articleProductName}>
                      Анна Белинская,
                    </span>{' '}
                    руководитель проектов бюро Atlas:
                  </div>
                </div>
                <div className={styles.articleProductText}>
                  <p>
                    Что это значит для города: появляется новый
                    многофункциональный и&nbsp;экономически активный район,
                    который отвечает на&nbsp;вызовы города и&nbsp;прилегающих
                    территорий&nbsp;&mdash; при позитивном сценарии
                    он&nbsp;становится импульсом для развития соседних
                    территорий. Кроме того, комплексная застройка позволяет
                    внедрить современные технологии, учитывающие глобальные
                    риски: например, экологичные, энергоэффективные или умные
                    решения,&nbsp;&mdash; а&nbsp;это повлияет
                    на&nbsp;благополучие города и&nbsp;горожан
                    в&nbsp;среднесрочной и&nbsp;долгосрочной перспективе.
                    <br />
                    <br />
                  </p>
                  <p>
                    Что это значит для будущих жителей: комплексный подход
                    позволяет сформировать жилую среду высокого качества, когда
                    приятно не&nbsp;только находиться в&nbsp;квартире,
                    но&nbsp;и&nbsp;работать, гулять и&nbsp;встречаться
                    с&nbsp;друзьями. В&nbsp;рамках комплексного освоения
                    закладываются решения, которые отвечают основным запросам
                    жителей на&nbsp;наличие в&nbsp;шаговой доступности
                    от&nbsp;дома общественных пространств, озелененных
                    и&nbsp;рекреационных территорий, а&nbsp;также соответствуют
                    социальным, коммерческим и&nbsp;культурно-развлекательным
                    функциям территории.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.articleContent}>
          <div className={styles.articleDescrImg}>
            <img src={image9} alt={''} />
          </div>

          <div className={styles.articleContentItem}>
            <div className={styles.articleContentItemTextTop}>
              <p>
                В&nbsp;Матвеевском кластере от&nbsp;ПИК будет построено около
                1&nbsp;млн.&nbsp;кв.&nbsp;м&nbsp;жилой недвижимости, школы,
                детсады, поликлиники и&nbsp;благоустроенные места для отдыха.
                Жители кластера смогут пользоваться разными объектами социальной
                и&nbsp;коммерческой инфраструктуры. Проекты кластера
                представлены не&nbsp;однотипной застройкой, а&nbsp;разными
                по&nbsp;этажности, фасадам, отделке, срокам строительства,
                строимости и&nbsp;дополнительным опциям корпусами.
              </p>
            </div>
          </div>
        </section>

        {/* <div style={{ background: '#e4f0d5' }}>
          <section className={styles.articleContent}>
            <div className={styles.articleCollectionBanner}>
              <CollectionBanner
                title={'Квартиры в готовых проектах'}
                lead={'Дома с инфраструктурой для жизни'}
                img={investmentImg}
                id={1}
                color={'#e4f0d5'}
                 currentPage={'1'}
              />
            </div>
          </section>
        </div> */}

        <section className={styles.articleContent}>
          <Articles excludeId='1' />
        </section>
        <Feedback />
      </main>
      <Footer />
    </>
  )
}
